import { Box, Typography } from '@mui/material';
import React from 'react';
import { MptLink } from 'components/MptLink';
import HomeIcon from '@mui/icons-material/Home';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ConditionalRender from 'components/ConditionalRender';

interface AddDeliveryAddressProps {
   text?: string;
   onOpen: () => void;
}

const AddDeliveryAddressLink: React.FC<AddDeliveryAddressProps> = ({ onOpen, text }) => {
   return (
      <>
         <MptLink underline="none" color="inherit" sx={{ cursor: 'pointer' }} onClick={onOpen}>
            <Box display="flex" alignItems="center" component="span">
               <ConditionalRender
                  condition={!!text}
                  componentIfTrue={<CreditCardIcon fontSize="medium" />}
                  componentIfFalse={<HomeIcon fontSize="medium" />}
               />
               <Typography ml={1} fontSize="1.2rem">
                  {text ? text : 'Add delivery address'}
               </Typography>
            </Box>
         </MptLink>
      </>
   );
};

export default AddDeliveryAddressLink;
